// Elements to toggle class when in view
const elementsToAnimate = document.querySelectorAll('.animation-fade-up, .animation-fade-left, .animation-fade-right');
const elementsToAnimateObserver = new IntersectionObserver((entries, observer) =>
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-animated');
            return;
        }

        if (entry.boundingClientRect.top > 0) {
            entry.target.classList.remove('is-animated');
        } else {
            entry.target.classList.add('is-animated');
        }

    }),
    {
        root: null,
        rootMargin: "-5%",
        threshold: 0,
    }
);
elementsToAnimate.forEach((el) => {
    elementsToAnimateObserver.observe(el);
});